var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onclick}},[_vm._v("Log out")])}
var staticRenderFns = []

export { render, staticRenderFns }